module.exports = __webpack_public_path__ + "static/media/Welding.fdb2860b.webp";